export class UserProfileDropdown {
  private profileState: string;
  private onLogout: () => void;

  constructor(private $state: ng.ui.IStateService) {}

  showUpdateProfile() {
    this.$state.go(this.profileState, {}, { reload: true });
  }
}

angular.module('capability-ng-global').component('userProfileDropdown', {
  transclude: true,
  controller: UserProfileDropdown,
  templateUrl: 'lib/global/components/user_profile_dropdown/user_profile_dropdown.html',
  controllerAs: '$ctrl',
  bindings: {
    profileState: '@',
    onLogout: '&'
  }
});



// WEBPACK FOOTER //
// ./app/lib/global/components/user_profile_dropdown/user_profile_dropdown.ts